import generateCalendarFile from './generateCalendarFile';
import type {
  ScheduleExporter,
  ScheduleExporterExportParams,
} from './ScheduleExporter';

export default class WebScheduleExporterImpl implements ScheduleExporter {
  // eslint-disable-next-line @typescript-eslint/require-await
  async export(params: ScheduleExporterExportParams) {
    const {supportGroupId} = params;

    const calendar = generateCalendarFile(params);

    const filename = `SupportGroupMeetings_${supportGroupId}.ics`;
    const file = new File([calendar], filename, {type: 'text/calendar'});
    const url = URL.createObjectURL(file);

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);

    URL.revokeObjectURL(url);
  }
}
